((document) => {
    const disableAnchor = function (e: MouseEvent) {
        if (e.ctrlKey || e.shiftKey || e.metaKey || e.button === 1) {
            return; // don't disable if opening new tab
        }

        const a = e.currentTarget as HTMLAnchorElement & { _enable?: () => void };

        if (a.dataset.clicked) {
            e.preventDefault();
            return false;
        }

        if (a.dataset.confirm && !confirm(a.dataset.confirm)) {
            e.preventDefault();
            return false;
        }
        
        const props = {
            display: a.style.display,
            width: a.style.width,
            innerHTML: a.innerHTML
        }

        if (a.dataset.spin != 'false') {
            a.style.display = 'inline-block';
            a.style.width = a.clientWidth + 'px';
            a.innerHTML = "<i class='fas fa-fw fa-circle-notch fa-spin'></i>";
            a.classList.add("disabled");
        }

        a.dataset.clicked = "true";

        a._enable = () => {
            a.style.display = props.display,
            a.style.width = props.width,
            a.innerHTML = props.innerHTML,
            a.classList.remove("disabled");
            delete a.dataset.clicked;
        }

        return true;
    }

    const anchors = Array.from(document.getElementsByTagName("a"));
    
    anchors.forEach(a => a.addEventListener("click", disableAnchor));
    
    window.addEventListener('pageshow', () => anchors.forEach(a => (a as any)._enable?.()));
})(document);